// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileLayout_wrapper__ZA+51","container":"ProfileLayout_container__2g5RF","content":"ProfileLayout_content__5NolG"};